import axios from '@/axios';
import router from '@/router';
import { dev } from '@/api/url';

const baseUrl = dev;
const headers = {
  'Content-type': 'application/json',
};

const config = {
  timeout: 30000,
  method: null,
  emulateJSON: true,
  url: '',
  headers,
  data: null,
};

export default {
  fetchAllScreens: () => {
    config.url = baseUrl + '/api/screens';
    config.method = 'get';

    return axios.request(config)
      .then(res => res.data)
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message;
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login');
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          ErrMsg = err.message || '予期しないエラー';
        }
        return ErrMsg;
      });
  },

  fetchScreenDetails: (screenId) => {
    config.url = `${baseUrl}/api/screens/${screenId}`;
    config.method = 'get';

    return axios.request(config)
      .then(res => res.data)
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message;
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login');
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          ErrMsg = err.message || '予期しないエラー';
        }
        return ErrMsg;
      });
  },

  deleteScreen: (screenId) => {
    config.url = `${baseUrl}/api/screens/${screenId}`;
    config.method = 'delete';

    return axios.request(config)
      .then(res => res.data)
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message;
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login');
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          ErrMsg = err.message || '予期しないエラー';
        }
        return ErrMsg;
      });
  },
  updateScreen: (screenId, newName, authUserId, sessionKey, staffName) => {
    config.url = `${baseUrl}/api/screen/edit`;
    config.method = 'POST';
    config.data = { screenId, screenName: newName, authInfo: { authUserId, sessionKey }, staffName };

    return axios.request(config)
      .then(res => res.data)
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message;
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.message || '認証エラー発生';
            router.push('/login');
          } else if (err.response.status === 404) {
            ErrMsg = err.response.data.message || '画面が見つかりません';
          } else {
            ErrMsg = err.response.data.message || 'その他のエラーメッセージ';
          }
        } else {
          ErrMsg = err.message || '予期しないエラー';
        }
        return ErrMsg;
      });
  },

};
